import React, { useState } from 'react';
import { Paper, IconButton, Grid, Button, ButtonGroup } from '@mui/material';
import { Typography } from '../../../../../components/Generic/StyledComponent';
import LabelValue from '../labelValue';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import EditIcon from '@rsuite/icons/Edit';
import { MutualAid } from 'src/services/api';
import { getCredentials } from 'src/hooks/useCredentials';
import { toast } from 'react-toastify';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { Modal } from 'rsuite';
import { LoadingButton } from '@mui/lab';

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#DB2228',
    color: '#ffffff',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}));

function BankDetails(props) {
  const {
    data,
    karzaData,
    setIsReload,
    isApproved,
    toggleApproved,
    isApprovedBtnPressed,
    isEditable,
    disabled,
    isVerifryButtonShow,
    pennyDropOverride
  } = props;
  const {
    claimId,
    subClaimId,
    accountHolderName,
    ifscCode,
    bankName,
    accountNumber
  } = data;

  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState({
    claimId: claimId,
    bankName: bankName,
    accountHolderName: accountHolderName,
    accountNumber: accountNumber,
    ifscCode: ifscCode
  });
  const [validation, setValidation] = useState({
    claimId: false,
    bankName: false,
    accountHolderName: false,
    accountNumber: false,
    ifscCode: false
  });
  const [reason, setReason] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { accessToken } = getCredentials();

  const outSideOnChange = (name, value) => {
    setEditData({ ...editData, [name]: value });
    if (value) {
      setValidation({ ...validation, [name]: false });
    } else {
      setValidation({ ...validation, [name]: true });
    }
  };

  const save = async () => {
    if (
      editData.bankName &&
      editData.accountHolderName &&
      editData.accountNumber &&
      editData.ifscCode
    ) {
      let data = {
        ...editData,
        subClaimId: subClaimId
      };
      await MutualAid.updateBankDetails(accessToken, data).then((res) => {
        setIsReload(true);
        setEdit(false);
      });
    } else {
    }
  };

  async function validatePennydrop() {
    setLoading(true);
    await MutualAid.validatePennydropDetails(
      accessToken,
      claimId,
      subClaimId,
      reason
    ).then((res) => {
      if (res.code == 200) {
        if (reason) {
          toast.success(`Override successfully `);
        } else {
          toast.success(`Pennydrop done successfully `);
        }
        setReason('');
        setOpen(false);
        setIsReload(true);
      } else {
        if (!reason) {
          setIsReload(true);
        }
        toast.error(res?.message);
      }
    });
    setLoading(false);
  }

  function validateKarzaChecks(condition) {
    if (karzaData === null)
      return { icon: CancelOutlinedIcon, color: '#DB2228', verify: false };
    else if (condition)
      return {
        icon: CheckCircleIcon,
        color: 'green',
        verify: true
      };
    else return { icon: CancelOutlinedIcon, color: '#DB2228', verify: false };
  }

  const { icon: IconComponent, color: iconColor } = validateKarzaChecks(
    karzaData?.pennyDropDone
  );
  const isShowVerifyIcon =
    karzaData?.nameMatched &&
    karzaData?.accountNumberMatched &&
    karzaData?.ifscMatched;

  const isShowOverrideIcon =
    karzaData?.accountNumberMatched && karzaData?.ifscMatched;

  return (
    <Paper style={{ padding: 16, marginTop: 15 }} variant="outlined">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: 16
        }}
      >
        <Typography
          color="rgba(79, 79, 79, 1)"
          style={{
            fontSize: 18,
            color: isApprovedBtnPressed && !isApproved && 'red'
          }}
        >
          Bank Details
        </Typography>
        <div style={{ display: 'flex' }}>
          <div>
            {isEditable ? (
              <IconButton
                style={{ padding: 5 }}
                onClick={toggleApproved}
                size="large"
                disabled={disabled}
              >
                {isApproved ? (
                  <CheckCircleIcon style={{ color: 'rgba(33, 150, 83, 1)' }} />
                ) : (
                  <CheckCircleOutlineOutlinedIcon
                    style={{ color: isApprovedBtnPressed ? 'red' : null }}
                  />
                )}
              </IconButton>
            ) : null}
          </div>
          {!isShowVerifyIcon && isEditable && edit == false ? (
            <div style={{ marginTop: 8, marginLeft: 5 }}>
              <EditIcon
                style={{ float: 'right', cursor: 'pointer' }}
                onClick={() => setEdit(!edit)}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {pennyDropOverride ? (
          <Typography
            color="red"
            style={{
              fontSize: 16
            }}
          >
            Pennydrop override
          </Typography>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Typography
              color="rgba(79, 79, 79, 1)"
              style={{
                fontSize: 16
              }}
            >
              Pennydrop
            </Typography>
            <div>
              <HtmlTooltip
                title={
                  <>
                    <span>
                      {!isShowVerifyIcon
                        ? 'Pennydrop pending'
                        : 'Pennydrop done successfully'}
                    </span>
                    <br />
                    {karzaData?.createdAt && (
                      <span>
                        Date:{' '}
                        {moment(karzaData?.createdAt).format('DD-MM-YYYY')}{' '}
                      </span>
                    )}
                  </>
                }
              >
                <IconButton>
                  <IconComponent style={{ color: iconColor }} />
                </IconButton>
              </HtmlTooltip>
            </div>
          </div>
        )}
        {!edit &&
          !isShowVerifyIcon &&
          isVerifryButtonShow &&
          !pennyDropOverride && (
            <ButtonGroup
              disableElevation
              variant="contained"
              aria-label="Disabled button group"
              size="small"
            >
              <Tooltip title="Retry pennydrop verification" arrow>
                <Button color="success" onClick={validatePennydrop}>
                  Retry
                </Button>
              </Tooltip>
              {!isShowOverrideIcon && (
                <Tooltip title="Override pennydrop verification" arrow>
                  <Button onClick={() => setOpen(true)}>Override</Button>
                </Tooltip>
              )}
            </ButtonGroup>
          )}
      </div>
      <LabelValue
        label="Bank Name"
        edittableOutSide={edit}
        editable={true}
        outSideEditData={editData.bankName}
        insideIconNotVisible={true}
        name={'bankName'}
        value={bankName}
        validation={validation.bankName}
        outSideOnChange={outSideOnChange}
      />
      <LabelValue
        label="Account Holder Name"
        editable={true}
        outSideEditData={editData.accountHolderName}
        edittableOutSide={edit}
        insideIconNotVisible={true}
        name={'accountHolderName'}
        value={accountHolderName}
        validation={validation.accountHolderName}
        outSideOnChange={outSideOnChange}
        icon={
          !pennyDropOverride &&
          validateKarzaChecks(karzaData?.nameMatched)?.icon
        }
        iconColor={validateKarzaChecks(karzaData?.nameMatched)?.color}
        placeholderTitle={
          !validateKarzaChecks(karzaData?.nameMatched)
            ? 'Account holder name verified'
            : `Account holder name unverified suggestion ${
                karzaData?.accountHolderName || ''
              }`
        }
      />
      <LabelValue
        label="Account Number"
        editable={true}
        outSideEditData={editData.accountNumber}
        edittableOutSide={edit}
        insideIconNotVisible={true}
        name={'accountNumber'}
        value={accountNumber}
        validation={validation.accountNumber}
        outSideOnChange={outSideOnChange}
        icon={
          !pennyDropOverride &&
          validateKarzaChecks(karzaData?.accountNumberMatched)?.icon
        }
        iconColor={validateKarzaChecks(karzaData?.accountNumberMatched)?.color}
        placeholderTitle={
          validateKarzaChecks(karzaData?.accountNumberMatched)?.verify
            ? 'Account number verified'
            : `Account number  unverified `
        }
      />
      <LabelValue
        label="IFSC Code"
        editable={true}
        outSideEditData={editData.ifscCode}
        edittableOutSide={edit}
        insideIconNotVisible={true}
        name={'ifscCode'}
        value={ifscCode}
        validation={validation.ifscCode}
        outSideOnChange={outSideOnChange}
        icon={
          !pennyDropOverride &&
          validateKarzaChecks(karzaData?.ifscMatched)?.icon
        }
        iconColor={validateKarzaChecks(karzaData?.ifscMatched)?.color}
        placeholderTitle={
          validateKarzaChecks(karzaData?.ifscMatched)?.verify
            ? 'IFSC code verified'
            : `IFSC code  unverified `
        }
      />
      {edit ? (
        <Grid container justifyContent="flex-end" style={{ marginTop: '15px' }}>
          <Grid item>
            <Button color="success" onClick={() => save()}>
              Save
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                setEdit(!edit);
                setEditData({
                  claimId: claimId,
                  bankName: bankName,
                  accountHolderName: accountHolderName,
                  accountNumber: accountNumber,
                  ifscCode: ifscCode
                });
                setValidation({
                  claimId: false,
                  bankName: false,
                  accountHolderName: false,
                  accountNumber: false,
                  ifscCode: false
                });
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      ) : (
        ''
      )}
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setReason('');
        }}
        className="penny-drop-modal"
        backdrop="static"
        size="xs"
      >
        <Modal.Header>
          <Modal.Title>Override Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
            style={{
              width: '98%',
              borderRadius: '5px',
              outline: 'none',
              padding: 4
            }}
            rows={3}
            maxLength={128}
            onChange={(e) => setReason(e.target.value)}
            autoFocus={true}
            placeholder="Enter reason"
          />
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            disabled={reason?.length < 2}
            variant="contained"
            size="small"
            color="success"
            onClick={validatePennydrop}
            loading={loading}
          >
            Submit
          </LoadingButton>
          <Button
            sx={{ marginLeft: 2 }}
            variant="contained"
            size="small"
            appearance="subtle"
            onClick={() => {
              setOpen(false);
              setReason('');
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </Paper>
  );
}

export default BankDetails;
